import React from 'react';
import {IHotelDetailsWithTerms} from 'gui/components/editors/hotelEditor/components/hotelDetailsForm';
import AdGoogleScore from '../adGoogleScore';

interface IAdHotelGoogleScoreProps {
  hotelDetails: IHotelDetailsWithTerms
}

const AdHotelGoogleScore = (props: IAdHotelGoogleScoreProps) => (
  <AdGoogleScore placeDetails={props.hotelDetails.hotel}/>
);

AdHotelGoogleScore.defaultProps = {
  hotelDetails: {hotel: {}}
};
export default AdHotelGoogleScore;
